import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";

import {
    IShuttleStatus,
    IModal,
    ModalType,
} from "Pages/Admin/ShuttleStatus/ShuttleStatus";
import useFetch from "Hooks/useFetch";
import useAlertContext from "Hooks/useAlertContext";
import { useEffect, useState } from "react";

interface IProps {
    modal: IModal | undefined;
    onSetModal: (name?: ModalType, row?: IShuttleStatus) => void;
}

interface IHealthReport {
    ReportTime: null | string;
    SystemName: null | string;
    LogicalProcessors: number;
    ProcessorLoad: number;
    DnsHostName: null | string;
    UserName: null | string;
    LastBootUpTime: null | string;
    TotalStorage: number;
    TotalPhysicalMemory: number;
    TotalVirtualMemory: number;
    FreeStorage: number;
    FreePhysicalMemory: number;
    FreeVirtualMemory: number;
    NumberOfProcesses: number;
    IntervalStorageConsumed: number;
    RunningIntegrations: null | string;
}

export default function HealthReportModal({ modal, onSetModal }: IProps) {
    const [report, setReport] = useState<IHealthReport>();

    const { get } = useFetch();
    const { newAlert } = useAlertContext();

    useEffect(() => {
        let ignore = false;

        getHealth();

        async function getHealth() {
            const row = modal?.row;
            if (!row) return;

            const id = `${row.company_id}_${row.machine_name}_${row.tag}`;
            const url = `/api/shuttle_status/health/${id}`;

            const response = await get(url);

            let data: any;
            try {
                data = await response.json();
            } catch {
                data = response;
            }
            console.log("Health report response: ", data);

            if (response.ok && !ignore) {
                setReport(data);
            } else {
                newAlert({
                    message: "Health report failed to generate",
                    color: "danger",
                });
            }
        }

        return () => {
            ignore = true;
        };
    }, [get, modal?.row, newAlert]);

    if (modal === undefined) return null;

    const row = modal.row;

    const closeModal = () => {
        onSetModal();
        setReport(undefined);
    };

    const isReportShown =
        report && Object.values(report).some((v) => v !== null && v !== 0);

    return (
        <Modal size="lg" isOpen={modal.name === "health"} toggle={closeModal}>
            <ModalHeader
                toggle={closeModal}
            >{`Health Report for ${row.machine_name}`}</ModalHeader>
            <ModalBody>
                {isReportShown ? (
                    <>
                        <Table striped>
                            <tbody>
                                {Object.entries(report).map(([k, v]) => (
                                    <tr key={k + v}>
                                        <td>
                                            <b>{k}:</b>
                                        </td>
                                        <td>
                                            {k === "RunningIntegrations"
                                                ? Object.entries(v).map(
                                                      ([kk, vv]) =>
                                                          `${kk}: ${vv}`
                                                  )
                                                : v}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <p>
                            Another report has been requested from the shuttle
                            and should be available momentarily.
                        </p>
                    </>
                ) : (
                    <p>
                        No health report is available. Another report has been
                        requested and should be available momentarily.
                    </p>
                )}
            </ModalBody>
        </Modal>
    );
}
